import {
  orderDetailSchema,
  ordersPageSchema,
  receiptInputSchema,
  type ReceiptInput,
} from "cadendar-shared/ordering/receipts";

export function createOrdersReceptionApi({
  baseUrl,
  token,
  onUnauthorized,
}: {
  baseUrl: string;
  token: string;
  onUnauthorized: () => void;
}) {
  const request = async (path: string, options?: RequestInit) => {
    const response = await fetch(`${baseUrl}${path}`, {
      ...options,
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      if (response.status === 401) onUnauthorized();
      const body: unknown = await response.json().catch(() => null);
      const message =
        typeof body === "object" &&
        body !== null &&
        "error" in body &&
        typeof body.error === "string"
          ? body.error
          : "Impossible de communiquer avec le service des commandes.";
      throw new Error(message);
    }
    return response.json();
  };
  const orderPath = (orderId: string) =>
    `/ordering/orders/${encodeURIComponent(orderId)}`;
  return {
    async listPendingOrders(offset = 0) {
      const parameters = new URLSearchParams({
        pendingOnly: "true",
        offset: String(offset),
      });
      return ordersPageSchema.parse(
        await request(`/ordering/orders?${parameters}`),
      );
    },
    async getOrder(orderId: string) {
      return orderDetailSchema.parse(await request(orderPath(orderId)));
    },
    async createReceipt(options: ReceiptInput & { orderId: string }) {
      const body = receiptInputSchema.parse({ lines: options.lines });
      return orderDetailSchema.parse(
        await request(`${orderPath(options.orderId)}/receipts`, {
          method: "POST",
          body: JSON.stringify(body),
        }),
      );
    },
  };
}

export type OrdersReceptionApi = ReturnType<typeof createOrdersReceptionApi>;
